<ion-nav #activityDetailsNav class="centered"></ion-nav>